/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterslatin
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Latin" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersLatin ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersLatin extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Latin', [
            {
                character: 'Ā',
                title: t('ee')
            },
            {
                character: 'ā',
                title: t('ef')
            },
            {
                character: 'Ă',
                title: t('eg')
            },
            {
                character: 'ă',
                title: t('eh')
            },
            {
                character: 'Ą',
                title: t('ei')
            },
            {
                character: 'ą',
                title: t('ej')
            },
            {
                character: 'Ć',
                title: t('ek')
            },
            {
                character: 'ć',
                title: t('el')
            },
            {
                character: 'Ĉ',
                title: t('em')
            },
            {
                character: 'ĉ',
                title: t('en')
            },
            {
                character: 'Ċ',
                title: t('eo')
            },
            {
                character: 'ċ',
                title: t('ep')
            },
            {
                character: 'Č',
                title: t('eq')
            },
            {
                character: 'č',
                title: t('er')
            },
            {
                character: 'Ď',
                title: t('es')
            },
            {
                character: 'ď',
                title: t('et')
            },
            {
                character: 'Đ',
                title: t('eu')
            },
            {
                character: 'đ',
                title: t('ev')
            },
            {
                character: 'Ē',
                title: t('ew')
            },
            {
                character: 'ē',
                title: t('ex')
            },
            {
                character: 'Ĕ',
                title: t('ey')
            },
            {
                character: 'ĕ',
                title: t('ez')
            },
            {
                character: 'Ė',
                title: t('fa')
            },
            {
                character: 'ė',
                title: t('fb')
            },
            {
                character: 'Ę',
                title: t('fc')
            },
            {
                character: 'ę',
                title: t('fd')
            },
            {
                character: 'Ě',
                title: t('fe')
            },
            {
                character: 'ě',
                title: t('ff')
            },
            {
                character: 'Ĝ',
                title: t('fg')
            },
            {
                character: 'ĝ',
                title: t('fh')
            },
            {
                character: 'Ğ',
                title: t('fi')
            },
            {
                character: 'ğ',
                title: t('fj')
            },
            {
                character: 'Ġ',
                title: t('fk')
            },
            {
                character: 'ġ',
                title: t('fl')
            },
            {
                character: 'Ģ',
                title: t('fm')
            },
            {
                character: 'ģ',
                title: t('fn')
            },
            {
                character: 'Ĥ',
                title: t('fo')
            },
            {
                character: 'ĥ',
                title: t('fp')
            },
            {
                character: 'Ħ',
                title: t('fq')
            },
            {
                character: 'ħ',
                title: t('fr')
            },
            {
                character: 'Ĩ',
                title: t('fs')
            },
            {
                character: 'ĩ',
                title: t('ft')
            },
            {
                character: 'Ī',
                title: t('fu')
            },
            {
                character: 'ī',
                title: t('fv')
            },
            {
                character: 'Ĭ',
                title: t('fw')
            },
            {
                character: 'ĭ',
                title: t('fx')
            },
            {
                character: 'Į',
                title: t('fy')
            },
            {
                character: 'į',
                title: t('fz')
            },
            {
                character: 'İ',
                title: t('ga')
            },
            {
                character: 'ı',
                title: t('gb')
            },
            {
                character: 'Ĳ',
                title: t('gc')
            },
            {
                character: 'ĳ',
                title: t('gd')
            },
            {
                character: 'Ĵ',
                title: t('ge')
            },
            {
                character: 'ĵ',
                title: t('gf')
            },
            {
                character: 'Ķ',
                title: t('gg')
            },
            {
                character: 'ķ',
                title: t('gh')
            },
            {
                character: 'ĸ',
                title: t('gi')
            },
            {
                character: 'Ĺ',
                title: t('gj')
            },
            {
                character: 'ĺ',
                title: t('gk')
            },
            {
                character: 'Ļ',
                title: t('gl')
            },
            {
                character: 'ļ',
                title: t('gm')
            },
            {
                character: 'Ľ',
                title: t('gn')
            },
            {
                character: 'ľ',
                title: t('go')
            },
            {
                character: 'Ŀ',
                title: t('gp')
            },
            {
                character: 'ŀ',
                title: t('gq')
            },
            {
                character: 'Ł',
                title: t('gr')
            },
            {
                character: 'ł',
                title: t('gs')
            },
            {
                character: 'Ń',
                title: t('gt')
            },
            {
                character: 'ń',
                title: t('gu')
            },
            {
                character: 'Ņ',
                title: t('gv')
            },
            {
                character: 'ņ',
                title: t('gw')
            },
            {
                character: 'Ň',
                title: t('gx')
            },
            {
                character: 'ň',
                title: t('gy')
            },
            {
                character: 'ŉ',
                title: t('gz')
            },
            {
                character: 'Ŋ',
                title: t('ha')
            },
            {
                character: 'ŋ',
                title: t('hb')
            },
            {
                character: 'Ō',
                title: t('hc')
            },
            {
                character: 'ō',
                title: t('hd')
            },
            {
                character: 'Ŏ',
                title: t('he')
            },
            {
                character: 'ŏ',
                title: t('hf')
            },
            {
                character: 'Ő',
                title: t('hg')
            },
            {
                character: 'ő',
                title: t('hh')
            },
            {
                character: 'Œ',
                title: t('hi')
            },
            {
                character: 'œ',
                title: t('hj')
            },
            {
                character: 'Ŕ',
                title: t('hk')
            },
            {
                character: 'ŕ',
                title: t('hl')
            },
            {
                character: 'Ŗ',
                title: t('hm')
            },
            {
                character: 'ŗ',
                title: t('hn')
            },
            {
                character: 'Ř',
                title: t('ho')
            },
            {
                character: 'ř',
                title: t('hp')
            },
            {
                character: 'Ś',
                title: t('hq')
            },
            {
                character: 'ś',
                title: t('hr')
            },
            {
                character: 'Ŝ',
                title: t('hs')
            },
            {
                character: 'ŝ',
                title: t('ht')
            },
            {
                character: 'Ş',
                title: t('hu')
            },
            {
                character: 'ş',
                title: t('hv')
            },
            {
                character: 'Š',
                title: t('hw')
            },
            {
                character: 'š',
                title: t('hx')
            },
            {
                character: 'Ţ',
                title: t('hy')
            },
            {
                character: 'ţ',
                title: t('hz')
            },
            {
                character: 'Ť',
                title: t('ia')
            },
            {
                character: 'ť',
                title: t('ib')
            },
            {
                character: 'Ŧ',
                title: t('ic')
            },
            {
                character: 'ŧ',
                title: t('id')
            },
            {
                character: 'Ũ',
                title: t('ie')
            },
            {
                character: 'ũ',
                title: t('if')
            },
            {
                character: 'Ū',
                title: t('ig')
            },
            {
                character: 'ū',
                title: t('ih')
            },
            {
                character: 'Ŭ',
                title: t('ii')
            },
            {
                character: 'ŭ',
                title: t('ij')
            },
            {
                character: 'Ů',
                title: t('ik')
            },
            {
                character: 'ů',
                title: t('il')
            },
            {
                character: 'Ű',
                title: t('im')
            },
            {
                character: 'ű',
                title: t('in')
            },
            {
                character: 'Ų',
                title: t('io')
            },
            {
                character: 'ų',
                title: t('ip')
            },
            {
                character: 'Ŵ',
                title: t('iq')
            },
            {
                character: 'ŵ',
                title: t('ir')
            },
            {
                character: 'Ŷ',
                title: t('is')
            },
            {
                character: 'ŷ',
                title: t('it')
            },
            {
                character: 'Ÿ',
                title: t('iu')
            },
            {
                character: 'Ź',
                title: t('iv')
            },
            {
                character: 'ź',
                title: t('iw')
            },
            {
                character: 'Ż',
                title: t('ix')
            },
            {
                character: 'ż',
                title: t('iy')
            },
            {
                character: 'Ž',
                title: t('iz')
            },
            {
                character: 'ž',
                title: t('ja')
            },
            {
                character: 'ſ',
                title: t('jb')
            }
        ]);
    }
}